



























































































































































































import SimpleMap from '../../core/components/SimpleMap.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import AlertBox from '../../core/components/AlertBox.vue';
import RanchSettingsPerVehicle from './RanchSettingsPerVehicle.vue';
import PreviewRanchSimulation from './PreviewRanchSimulation.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    formatDate,
    getAlertColorByPriority,
    matchedIndexIdInArray,
    downloadJsonData,
    downloadJsonDataEachKeiAsSheet,
    getCurrentTime,
    getDateAsMoment
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import {
    MsgBox,
    Button,
    Combobox,
    LDialogOld,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import moment from 'moment';
import { dateTypes } from '../../core/models';
import { getValueByType } from '../../core/api';
@Component({
    components: {
        Loading,
        SimpleMap,
        SimpleTable,
        Combobox,
        Button,
        LDialogOld,
        RanchSettingsPerVehicle,
        PreviewRanchSimulation,
        AlertBox
    }
})
export default class ModalRanchSimulator extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop({ default: null }) mostRepresentativeImage: object | null;
    @Prop({
        default() {
            return [];
        }
    })
    ignoredPeriodsList: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    cropTypes: Array<object>;
    @Prop({
        default() {
            return [];
        }
    })
    vehiclesOptions: Array<object>;
    @Prop({ default: {} }) ranchSimulatorConfig: object;
    @Prop({ default: null }) geojsonSegmentsOfWork: null | object;
    @Prop({ default: '' }) previousRanchSimulatorConfig: string;
    @Prop({ default: -1 }) ranchId: number;
    @Prop({ default: -1 }) harvestId: number;
    @Prop({ default: false }) ranchHasCsv: boolean;
    @Prop({ default: '' }) ranchStartDate: string;
    @Prop({ default: '' }) ranchEndDate: string;
    @Prop({
        default() {
            return [];
        }
    })
    booleanOptions: Array<object>;
    payloadPrevisualization: object = {};
    vehiclesList: Array<object> = [];
    noteDescription: string = '';
    performanceSelected: any = null;
    performanceRV: boolean = false;
    selectedTab: any = null;
    selectedMainTab: any = null;
    mainTabs: string[] = ['Configuración'];
    csvAlert: string = 'Los cálculos se verán afectados por el CSV de la chacra';
    performanceOptions: Array<object> = [
        {
            id: 1,
            value: 'Si',
            kei: true
        },
        {
            id: 2,
            value: 'No',
            kei: false
        }
    ];
    previewData: object = {};
    loadingPreview: boolean = false;

    //LoadingDialog
    pendingRequest: boolean = false;
    msgLoadingDialog: string = '';
    errorResponse: any = {};
    successPost: boolean | null = null;
    parseValue: Function = getValueByType;

    get showSettingsPerVehicle() {
        if (Object.values(this.ranchSimulatorConfig).length == 0) {
            return false;
        }
        return true;
    }

    get getConfigsPerVehicle(): HTMLFormElement {
        return this.$refs.refRanchSettingsPerVehicle as HTMLFormElement;
    }

    get isPreviewing() {
        if (this.selectedMainTab == 1) {
            return true;
        }
        return false;
    }

    showLoadingDialog(msg) {
        this.pendingRequest = true;
        this.successPost = null;
        this.msgLoadingDialog = msg;
    }

    closeModalLoadingDialog() {
        this.pendingRequest = false;
        this.successPost = null;
        this.msgLoadingDialog = '';
        // this.enableScrollLoadingDialog();
    }

    showSuccessLoadingDialog(msg) {
        this.pendingRequest = true;
        this.successPost = true;
        this.msgLoadingDialog = msg;

        setTimeout(() => {
            this.closeModalLoadingDialog();
            this.closeModal();
        }, 1000);
    }

    get getAlertColor() {
        return getAlertColorByPriority();
    }
    showCatchLoadingDialog(error) {
        let self = this;
        self.successPost = false;
        self.errorResponse = {};
        self.msgLoadingDialog = '';
        if (error && error.response && error.response.data && error.response.data.message) {
            self.msgLoadingDialog = error.response.data.message;
        } else {
            self.msgLoadingDialog = 'Ocurrió un error';
            self.errorResponse = error.response.data;
        }
    }

    @Emit()
    loadPreviousConfig(config) {}

    closePrevisualization() {
        this.removeLastVehicleTab(); // remove previsualization tab
        this.setPreviewData({});
    }

    removeLastVehicleTab() {
        if (this.mainTabs.length > 1) {
            this.mainTabs.splice(1, 1);
        }
    }

    addPreviewTab(text) {
        this.removeLastVehicleTab();
        this.mainTabs.push(text);
    }

    selectPreviewTab() {
        this.selectedMainTab = 1;
    }

    setPreviewData(data) {
        this.previewData = data;
    }

    exportSimulationConfig() {
        let settings = this.payloadPrevisualization;
        let fileName = 'config_simulacion_chacra_' + this.ranchId + '_' + getCurrentTime(dateTypes.globalFilterDateFormat);
        let jsonData = {
            calibraciones: this.getCalibrationsParsed(this.parseList(settings['calibrations'])),
            pasadas_calibracion: this.getCalibrationPasses(settings['calibrations']),
            configuraciones: this.getConfigurationsParsed(this.parseList(settings['vehicle_configs'])),
            descalibraciones_diarias: this.getParsedVehicleAreaByDay(this.parseList(settings['day_vehicle_area'])),
            factores_manuales: this.getParsedManualFactors(this.parseList(settings['custom_calibrations'])),
            periodos_ignorados: this.getParsedIgnoredPeriods(this.parseList(settings['error_lapses'])),
            csvs: this.parseList(settings['performance_map_csvs'])
        };
        downloadJsonDataEachKeiAsSheet(fileName, jsonData);
    }

    getParsedIgnoredPeriods(list) {
        if (list.length !== 0) {
            list = list.map(function(config) {
                return {
                    vehiculo: config['vehiculo'],
                    id: config['id'],
                    fecha_inicio: config['start_date'],
                    fecha_fin: config['end_date'],
                    calculo_area_sin_rendimiento: config['calculate_without_performance'],
                    humedad_descartada: config['discard_humidity'],
                    humedad_descartada_csv: config['discard_humidity_csv'],
                    rendimiento_descartado: config['discard_performance'],
                    rendimiento_descartado_csv: config['discard_performance_csv'],
                    segmento_descartado: config['discard_segment']
                };
            });
        }
        return list;
    }
    getParsedManualFactors(list) {
        if (list.length !== 0) {
            list = list.map(function(config) {
                return {
                    vehiculo: config['vehiculo'],
                    id: config['id'],
                    fecha_inicio: config['start_date'],
                    fecha_fin: config['end_date'],
                    factor_calibracion_porcentaje: config['calibration_factor'],
                    factor_calibracion_humedad_porcentaje: config['humidity_calibration_factor']
                };
            });
        }
        return list;
    }
    getParsedVehicleAreaByDay(list) {
        if (list.length !== 0) {
            list = list.map(function(config) {
                return {
                    vehiculo: config['vehiculo'],
                    id: config['id'],
                    fecha: config['date'],
                    factor_calibracion_porcentaje: config['calibration_factor'],
                    factor_calibracion_humedad_porcentaje: config['humidity_calibration_factor'],
                    area: config['area']
                };
            });
        }
        return list;
    }
    getConfigurationsParsed(list) {
        if (list.length !== 0) {
            list = list.map(function(config) {
                return {
                    vehiculo: config['vehiculo'],
                    id: config['id'],
                    fecha: config['configuration_date'],
                    variable_trabajo: config['work_variable'],
                    ancho_trabajo: config['work_width'],
                    delay_var_trabajo: config['work_variable_delay'],
                    gps_desde_maquina: config['has_rtk'],
                    acollarada: config['encased']
                };
            });
        }
        return list;
    }

    getCalibrationsParsed(list) {
        if (list.length !== 0) {
            list = list.map(function(calibration) {
                return {
                    id: calibration['id'],
                    vehiculo: calibration['vehiculo'],
                    fecha: calibration['date'],
                    funcion_calibracion: calibration['function'],
                    maquinista: calibration['operator'],
                    ancho_trabajo: calibration['work_width'],
                    tipo_cultivo: calibration['harvest_type'],
                    aplicada: calibration['active_calibration'],
                    factor_cal_humedad: calibration['humidity_calibration_factor'],
                    variable_humedad: calibration['humidity_variable'],
                    factor_cal_peso: calibration['weight_calibration_factor'],
                    variable_rendimiento: calibration['weight_variable'],
                    comentarios: calibration['comments'],
                    delay: calibration['delay'],
                    ignorar_telemetria: calibration['force_no_telemetry']
                };
            });
        }
        return list;
    }

    getCalibrationPasses(calibrations) {
        let passes: Array<object> = [];
        //este metodo genera una lista de pasadas de calibracion
        //para mostrarlas en una hoja en el excel
        //Agrego a cada pasada el mismo ID de la calibracion para tener referencia en el excel
        for (let index = 0; index < calibrations.length; index++) {
            //recorro las calibraciones
            let calibration = calibrations[index];
            let calibrationPasses = this.parseList(calibration['calibration_passes']);

            //recorro las pasadas
            for (let b = 0; b < calibrationPasses.length; b++) {
                let currentItem = calibrationPasses[b];

                calibrationPasses[b] = {
                    vehiculo: calibration['vehiculo'],
                    id: currentItem['id'],
                    calibracion: calibration['id'],
                    fecha_inicio: currentItem['start_date'],
                    fecha_fin: currentItem['end_date'],
                    humedad_maquina: currentItem['measured_humidity'],
                    humedad_medida: currentItem['humidity'],
                    humedad_calculada: currentItem['calculated_humidity'],
                    peso_maquina: currentItem['measured_weight'],
                    peso_medido: currentItem['weight'],
                    rinde_maquina: currentItem['rinde_maquina'],
                    rinde_medido: currentItem['rinde_medido'],
                    factor_humedad: currentItem['humidity_calibration_factor'],
                    factor_rinde: currentItem['performance_calibration_factor'],
                    peso_calculado: currentItem['calculated_weight'],
                    area: currentItem['area']
                };
            }

            //voy agregando las nuevas pasadas con el ID a la lista
            passes = [...passes, ...calibrationPasses];
        }
        // console.log('passes', passes);
        return passes;
    }

    parseList(list) {
        let self = this;
        //este metodo parsea las listas para exportarlas a excel
        //eliminando keys innecesarias
        if (list.length !== 0) {
            let keisToRemove = [
                'disableDelete',
                'enabled',
                'hour_start',
                'hour_end',
                'pending',
                'vehicle_id',
                'vehicle'
            ];
            list.map(function(item) {
                for (let index = 0; index < keisToRemove.length; index++) {
                    const currentKei = keisToRemove[index];
                    if (item[currentKei]) {
                        delete item[currentKei];
                    }
                    if (item['date']) {
                        item['date'] = self.dateFormatter(item['date']);
                    }
                    if (item['start_date']) {
                        item['start_date'] = self.dateFormatter(item['start_date']);
                    }
                    if (item['end_date']) {
                        item['end_date'] = self.dateFormatter(item['end_date']);
                    }
                    if (item['configuration_date']) {
                        item['configuration_date'] = self.dateFormatter(item['configuration_date']);
                    }
                }
            });
        }

        return list;
    }

    dateFormatter(value) {
        if (value.indexOf('a las') !== -1) {
            return value;
        } else {
            let date = getDateAsMoment(value, dateTypes.globalFilterDateFormat)
            if (!date.isValid()) {
                return '-';
            } else {
                return formatDate(value);
            }
        }
    }

     getIdValue(id: number | string){
        // console.log("getIdValue", id);
        return typeof id === 'string' ? '' : id
    }

    getRowsWithVehicleData(list, currentVehicleID) {
        let self = this;
        if (list.length !== 0) {
            list = list.map(function(item) {
                return {
                    ...item,
                    id: self.getIdValue(item['id']),
                    vehiculo: '[' + currentVehicleID + '] -' + self.getVehicleDescription(currentVehicleID)
                };
            });
        }
        return list;
    }

    previewAction() {
        //this.getConfigsPerVehicle > referencia al componente que se repite
        //para generar la previsualizacion voy recorriendo todas las referencias
        //que tiene el componente RanchSettingsPerVehicle y voy obteniendo de cada uno cada lista
        //asi voy generando una lista con los datos de cada vehiculo
        let calibrations: Array<object> = [];
        let errorLapses: Array<object> = [];
        let manualFactors: Array<object> = [];
        let configurations: Array<object> = [];
        let dayVehicleArea: Array<object> = [];
        let vehicles: Array<number> = [];

        for (let i = 0; i < this.getConfigsPerVehicle.length; i++) {
            //voy uno por uno para obtener cada lista de cada componente
            let item: any = this.getConfigsPerVehicle[i];
            let currentVehicleID = item.getCurrentVehicleID();
            let currentCalibration = this.getRowsWithVehicleData(item.getCalibrations(), currentVehicleID);
            let currentErrorLapses = this.getRowsWithVehicleData(item.getErrorLapses(), currentVehicleID);
            let currentManualFactors = this.getRowsWithVehicleData(item.getManualFactors(), currentVehicleID);
            let currentConfigs = this.getRowsWithVehicleData(item.getConfigurations(), currentVehicleID);
            let currentDayVehicleArea = this.getRowsWithVehicleData(item.getDayVehicleArea(), currentVehicleID);
            calibrations = [...calibrations, ...currentCalibration];
            errorLapses = [...errorLapses, ...currentErrorLapses];
            manualFactors = [...manualFactors, ...currentManualFactors];
            configurations = [...configurations, ...currentConfigs];
            dayVehicleArea = [...dayVehicleArea, ...currentDayVehicleArea];
            vehicles.push(currentVehicleID);
        }

        //checkeo que cada vehiculo tenga al menos una configuration
        configurations = this.getItemsIgnoringUncheckedItems(configurations);
        let checkIfConfigsAreValidToPreview = this.checkConfigurations(configurations, vehicles);
        if (checkIfConfigsAreValidToPreview) {
            //genero diccionario para enviar a backend
            let data = {
                error_lapses: this.getItemsIgnoringUncheckedItems(errorLapses), //periodos ignorados
                low_flow:
                    this.performanceSelected == null
                        ? false
                        : this.performanceSelected['value'] === 'Si'
                        ? true
                        : false, //bajo rinde
                calibrations: this.getItemsIgnoringUncheckedItems(calibrations), //calibraciones
                custom_calibrations: this.getItemsIgnoringUncheckedItems(manualFactors), //factores manuales
                day_vehicle_area: this.getItemsIgnoringUncheckedItems(dayVehicleArea), //descalibraciones diarias
                vehicle_configs: configurations, //configuraciones
                performance_map_csvs: [], //csvs del vehiculo,
                id: Number(this.ranchId)
            };
            this.previewChanges(data);
        }
    }

    checkConfigurations(configurations, vehicles) {
        this.loadingPreview = true;
        this.showLoadingDialog('Cargando previsualización...');
        let self = this;
        for (let i = 0; i < vehicles.length; i++) {
            let currentVehicle = vehicles[i];
            let indexVehicleInConfigurationsList = configurations.findIndex(
                config => config['vehicle_id'] == currentVehicle
            );
            if (indexVehicleInConfigurationsList == -1) {
                this.loadingPreview = false;
                this.showCatchLoadingDialog({
                    response: {
                        data: {
                            message:
                                'El vehículo: <b>' +
                                self.getVehicleDescription(currentVehicle) +
                                '</b><br> No tiene una configuración o no está habilitada'
                        }
                    }
                });
                return false;
            }
        }
        return true;
    }

    getVehicleDescription(id: number) {
        let data = this.getVehicleData(id);
        return data['description'] + '(' + data['vin'] + ')';
    }

    getVehicleData(vehicleId: number) {
        let data = '';
        let index = matchedIndexIdInArray(this.vehiclesOptions, vehicleId);
        if (index > -1) {
            let vehicle = this.vehiclesOptions[index];
            return vehicle;
        }
        return data;
    }

    getItemsIgnoringUncheckedItems(list: Array<object>) {
        let newList = JSON.parse(JSON.stringify(list));
        return newList.filter(function(item) {
            return item['enabled'];
        });
    }

    previewChanges(data) {
        this.loadingPreview = true;
        this.payloadPrevisualization = data;
        this.showLoadingDialog('Cargando previsualización...');
        InsuranceServices.getRanchConfigSimulatorPreview(data)
            .then(res => {
                this.loadingPreview = false;
                this.closeModalLoadingDialog();
                this.previewSimulation(res);
            })
            .catch(err => {
                this.payloadPrevisualization = {};
                this.loadingPreview = false;
                this.showCatchLoadingDialog(err);
            });
    }

    previewSimulation(data) {
        this.closePrevisualization();
        let self = this;
        setTimeout(() => {
            self.addPreviewTab('Previsualización');
            self.selectPreviewTab();
            self.setPreviewData({
                oldConfig: self.ranchSimulatorConfig,
                newConfig: data
            });
        }, 0);
    }

    updatePerformanceSelected(value) {
        this.performanceSelected = value;
    }
    updatePerformanceRV(value) {
        this.performanceRV = value;
    }
    setVehiclesList(value) {
        this.vehiclesList = value;
    }

    @Emit()
    closeModal() {}

    updateLowFlowSelected(value) {
        let option = value ? this.booleanOptions[0] : this.booleanOptions[1];
        this.updatePerformanceSelected(option);
    }

    setRanchConfig() {
        // console.log('configuracion de la chacra', this.ranchSimulatorConfig);
        this.setVehiclesList(this.ranchSimulatorConfig['vehicles']);
        // this.setPerformanceMapImage()
        this.updateLowFlowSelected(this.ranchSimulatorConfig['ranch']['low_flow']);
        this.previousRanchSimulatorConfig = JSON.stringify(this.ranchSimulatorConfig);
    }

    mounted() {
        this.setRanchConfig();
    }
}
